
import { Component, Vue } from "vue-property-decorator";
import { Settings } from "../../core/services/configService";
import { CrudService } from "../../core/services/crudService";
import ProductCard from "../../components/productCard/productCard.vue";


@Component({
  components: {
    ProductCard,
  },
})
export default class TrendingProducts extends Vue {
  products: any[] = [];

  async mounted() {
    let url = `${Settings.HostName}/api/products/trending-products`;
    let data = await new CrudService().httpGet(url);
    if (data == null || !data.ok) {
      console.error("Crash getting trending products");
      return;
    }
    
    this.products = data.data.slice(0,4);
    this.checkScroll();
    window.addEventListener("resize", this.checkScroll);
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.checkScroll);
  }

  checkScroll() {
    this.$nextTick(() => {
      const container = this.$refs.trendingBannerContainer as HTMLElement | null;
      const list = this.$refs.trendingBannerList as HTMLElement | null;

      if (container && list) {
        const hasHorizontalScroll = list.scrollWidth > container.clientWidth;

        list.style.justifyContent = hasHorizontalScroll ? "flex-start" : "center";
      }
    });
  }
}
